/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as AdminrootImport } from './routes/admin/__root';
import { Route as SignupImport } from './routes/signup';
import { Route as LoginImport } from './routes/login';
import { Route as AuthenticatedImport } from './routes/_authenticated';
import { Route as EventEventLinkIdImport } from './routes/event/$eventLinkId';
import { Route as AuthenticatedDashboardImport } from './routes/_authenticated/dashboard';
import { Route as AuthenticatedEventsIndexImport } from './routes/_authenticated/events/index';
import { Route as AuthenticatedEventsNewImport } from './routes/_authenticated/events/new';
import { Route as AuthenticatedEventsEventIdShareImport } from './routes/_authenticated/events/$eventId/share';
import { Route as AuthenticatedEventsEventIdGalleryImport } from './routes/_authenticated/events/$eventId/gallery';

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')();
const AdminLoginLazyImport = createFileRoute('/admin/login')();
const AdminDashboardLazyImport = createFileRoute('/admin/dashboard')();

// Create/Update Routes

const AdminrootRoute = AdminrootImport.update({
  id: '/admin/__root',
  getParentRoute: () => rootRoute,
} as any);

const SignupRoute = SignupImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRoute,
} as any);

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any);

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route));

const AdminLoginLazyRoute = AdminLoginLazyImport.update({
  id: '/admin/login',
  path: '/admin/login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/admin/login.lazy').then((d) => d.Route));

const AdminDashboardLazyRoute = AdminDashboardLazyImport.update({
  id: '/admin/dashboard',
  path: '/admin/dashboard',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/admin/dashboard.lazy').then((d) => d.Route),
);

const EventEventLinkIdRoute = EventEventLinkIdImport.update({
  id: '/event/$eventLinkId',
  path: '/event/$eventLinkId',
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedDashboardRoute = AuthenticatedDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedEventsIndexRoute = AuthenticatedEventsIndexImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedEventsNewRoute = AuthenticatedEventsNewImport.update({
  id: '/events/new',
  path: '/events/new',
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedEventsEventIdShareRoute =
  AuthenticatedEventsEventIdShareImport.update({
    id: '/events/$eventId/share',
    path: '/events/$eventId/share',
    getParentRoute: () => AuthenticatedRoute,
  } as any);

const AuthenticatedEventsEventIdGalleryRoute =
  AuthenticatedEventsEventIdGalleryImport.update({
    id: '/events/$eventId/gallery',
    path: '/events/$eventId/gallery',
    getParentRoute: () => AuthenticatedRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexLazyImport;
      parentRoute: typeof rootRoute;
    };
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthenticatedImport;
      parentRoute: typeof rootRoute;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    '/signup': {
      id: '/signup';
      path: '/signup';
      fullPath: '/signup';
      preLoaderRoute: typeof SignupImport;
      parentRoute: typeof rootRoute;
    };
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof AuthenticatedDashboardImport;
      parentRoute: typeof AuthenticatedImport;
    };
    '/admin/__root': {
      id: '/admin/__root';
      path: '/admin';
      fullPath: '/admin';
      preLoaderRoute: typeof AdminrootImport;
      parentRoute: typeof rootRoute;
    };
    '/event/$eventLinkId': {
      id: '/event/$eventLinkId';
      path: '/event/$eventLinkId';
      fullPath: '/event/$eventLinkId';
      preLoaderRoute: typeof EventEventLinkIdImport;
      parentRoute: typeof rootRoute;
    };
    '/admin/dashboard': {
      id: '/admin/dashboard';
      path: '/admin/dashboard';
      fullPath: '/admin/dashboard';
      preLoaderRoute: typeof AdminDashboardLazyImport;
      parentRoute: typeof rootRoute;
    };
    '/admin/login': {
      id: '/admin/login';
      path: '/admin/login';
      fullPath: '/admin/login';
      preLoaderRoute: typeof AdminLoginLazyImport;
      parentRoute: typeof rootRoute;
    };
    '/_authenticated/events/new': {
      id: '/_authenticated/events/new';
      path: '/events/new';
      fullPath: '/events/new';
      preLoaderRoute: typeof AuthenticatedEventsNewImport;
      parentRoute: typeof AuthenticatedImport;
    };
    '/_authenticated/events/': {
      id: '/_authenticated/events/';
      path: '/events';
      fullPath: '/events';
      preLoaderRoute: typeof AuthenticatedEventsIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    '/_authenticated/events/$eventId/gallery': {
      id: '/_authenticated/events/$eventId/gallery';
      path: '/events/$eventId/gallery';
      fullPath: '/events/$eventId/gallery';
      preLoaderRoute: typeof AuthenticatedEventsEventIdGalleryImport;
      parentRoute: typeof AuthenticatedImport;
    };
    '/_authenticated/events/$eventId/share': {
      id: '/_authenticated/events/$eventId/share';
      path: '/events/$eventId/share';
      fullPath: '/events/$eventId/share';
      preLoaderRoute: typeof AuthenticatedEventsEventIdShareImport;
      parentRoute: typeof AuthenticatedImport;
    };
  }
}

// Create and export the route tree

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute;
  AuthenticatedEventsNewRoute: typeof AuthenticatedEventsNewRoute;
  AuthenticatedEventsIndexRoute: typeof AuthenticatedEventsIndexRoute;
  AuthenticatedEventsEventIdGalleryRoute: typeof AuthenticatedEventsEventIdGalleryRoute;
  AuthenticatedEventsEventIdShareRoute: typeof AuthenticatedEventsEventIdShareRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedEventsNewRoute: AuthenticatedEventsNewRoute,
  AuthenticatedEventsIndexRoute: AuthenticatedEventsIndexRoute,
  AuthenticatedEventsEventIdGalleryRoute:
    AuthenticatedEventsEventIdGalleryRoute,
  AuthenticatedEventsEventIdShareRoute: AuthenticatedEventsEventIdShareRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute;
  '': typeof AuthenticatedRouteWithChildren;
  '/login': typeof LoginRoute;
  '/signup': typeof SignupRoute;
  '/dashboard': typeof AuthenticatedDashboardRoute;
  '/admin': typeof AdminrootRoute;
  '/event/$eventLinkId': typeof EventEventLinkIdRoute;
  '/admin/dashboard': typeof AdminDashboardLazyRoute;
  '/admin/login': typeof AdminLoginLazyRoute;
  '/events/new': typeof AuthenticatedEventsNewRoute;
  '/events': typeof AuthenticatedEventsIndexRoute;
  '/events/$eventId/gallery': typeof AuthenticatedEventsEventIdGalleryRoute;
  '/events/$eventId/share': typeof AuthenticatedEventsEventIdShareRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute;
  '': typeof AuthenticatedRouteWithChildren;
  '/login': typeof LoginRoute;
  '/signup': typeof SignupRoute;
  '/dashboard': typeof AuthenticatedDashboardRoute;
  '/admin': typeof AdminrootRoute;
  '/event/$eventLinkId': typeof EventEventLinkIdRoute;
  '/admin/dashboard': typeof AdminDashboardLazyRoute;
  '/admin/login': typeof AdminLoginLazyRoute;
  '/events/new': typeof AuthenticatedEventsNewRoute;
  '/events': typeof AuthenticatedEventsIndexRoute;
  '/events/$eventId/gallery': typeof AuthenticatedEventsEventIdGalleryRoute;
  '/events/$eventId/share': typeof AuthenticatedEventsEventIdShareRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexLazyRoute;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/login': typeof LoginRoute;
  '/signup': typeof SignupRoute;
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute;
  '/admin/__root': typeof AdminrootRoute;
  '/event/$eventLinkId': typeof EventEventLinkIdRoute;
  '/admin/dashboard': typeof AdminDashboardLazyRoute;
  '/admin/login': typeof AdminLoginLazyRoute;
  '/_authenticated/events/new': typeof AuthenticatedEventsNewRoute;
  '/_authenticated/events/': typeof AuthenticatedEventsIndexRoute;
  '/_authenticated/events/$eventId/gallery': typeof AuthenticatedEventsEventIdGalleryRoute;
  '/_authenticated/events/$eventId/share': typeof AuthenticatedEventsEventIdShareRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | ''
    | '/login'
    | '/signup'
    | '/dashboard'
    | '/admin'
    | '/event/$eventLinkId'
    | '/admin/dashboard'
    | '/admin/login'
    | '/events/new'
    | '/events'
    | '/events/$eventId/gallery'
    | '/events/$eventId/share';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | ''
    | '/login'
    | '/signup'
    | '/dashboard'
    | '/admin'
    | '/event/$eventLinkId'
    | '/admin/dashboard'
    | '/admin/login'
    | '/events/new'
    | '/events'
    | '/events/$eventId/gallery'
    | '/events/$eventId/share';
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/signup'
    | '/_authenticated/dashboard'
    | '/admin/__root'
    | '/event/$eventLinkId'
    | '/admin/dashboard'
    | '/admin/login'
    | '/_authenticated/events/new'
    | '/_authenticated/events/'
    | '/_authenticated/events/$eventId/gallery'
    | '/_authenticated/events/$eventId/share';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  SignupRoute: typeof SignupRoute;
  AdminrootRoute: typeof AdminrootRoute;
  EventEventLinkIdRoute: typeof EventEventLinkIdRoute;
  AdminDashboardLazyRoute: typeof AdminDashboardLazyRoute;
  AdminLoginLazyRoute: typeof AdminLoginLazyRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  AdminrootRoute: AdminrootRoute,
  EventEventLinkIdRoute: EventEventLinkIdRoute,
  AdminDashboardLazyRoute: AdminDashboardLazyRoute,
  AdminLoginLazyRoute: AdminLoginLazyRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/login",
        "/signup",
        "/admin/__root",
        "/event/$eventLinkId",
        "/admin/dashboard",
        "/admin/login"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/dashboard",
        "/_authenticated/events/new",
        "/_authenticated/events/",
        "/_authenticated/events/$eventId/gallery",
        "/_authenticated/events/$eventId/share"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/signup": {
      "filePath": "signup.tsx"
    },
    "/_authenticated/dashboard": {
      "filePath": "_authenticated/dashboard.tsx",
      "parent": "/_authenticated"
    },
    "/admin/__root": {
      "filePath": "admin/__root.tsx"
    },
    "/event/$eventLinkId": {
      "filePath": "event/$eventLinkId.tsx"
    },
    "/admin/dashboard": {
      "filePath": "admin/dashboard.lazy.tsx"
    },
    "/admin/login": {
      "filePath": "admin/login.lazy.tsx"
    },
    "/_authenticated/events/new": {
      "filePath": "_authenticated/events/new.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/events/": {
      "filePath": "_authenticated/events/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/events/$eventId/gallery": {
      "filePath": "_authenticated/events/$eventId/gallery.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/events/$eventId/share": {
      "filePath": "_authenticated/events/$eventId/share.tsx",
      "parent": "/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
